import { useMediaQuery } from 'react-responsive';

import { browserBreakpoints } from 'src/components/Responsive/Breakpoints';

export const mediaQueries = {
  mobile: `(max-width: ${browserBreakpoints.mobile}px)`,
  tablet: `(min-width: ${browserBreakpoints.mobile + 1}px) and (max-width: ${browserBreakpoints.tablet}px)`,
  desktop: `(min-width: ${browserBreakpoints.tablet + 1}px) and (max-width: ${browserBreakpoints.desktop}px)`,
  desktopOrLarge: `(min-width: ${browserBreakpoints.tablet + 1}px)`,
  desktopLarge: `(min-width: ${browserBreakpoints.desktop + 1}px)`,
};

/**
 * A hook returns responsive condition
 */
export const useMobile = (): boolean => useMediaQuery({ query: mediaQueries.mobile });

export const useTablet = (): boolean => useMediaQuery({ query: mediaQueries.tablet });

export const useDesktop = (): boolean => useMediaQuery({ query: mediaQueries.desktop });

export const useDesktopOrLarge = (): boolean => useMediaQuery({ query: mediaQueries.desktopOrLarge });

export const useDesktopLarge = (): boolean => useMediaQuery({ query: mediaQueries.desktopLarge });
